(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["igp-poster-guidance"] && !Shopify.designMode) return;
  try {
    const marker = document.getElementById('igp-poster-guidance-marker');
  if (marker) {
    const main = document.getElementById('MainContent');
    const optionNames = new Set(marker.dataset.optionNames.split(','));
    const notes = new Map();
    let scheduled = false;
    const relocateGuidance = () => {
      scheduled = false;
      const details = main?.querySelector('.ig-sign-details');
      if (!details) return;
      main.querySelectorAll('.cl-po--option[data-option]').forEach(option => {
        const name = option.dataset.option;
        if (!optionNames.has(name)) return;
        const help = option.querySelector(':scope > .cl-po--help');
        const text = help?.textContent.trim();
        if (!help || !text) return;
        let container = details.querySelector('#igp-poster-production-details');
        if (!container) {
          container = document.createElement('div');
          container.id = 'igp-poster-production-details';
          const specifications = details.querySelector('ul');
          if (specifications) specifications.after(container);
          else details.append(container);
        }
        let note = notes.get(name);
        if (!note?.isConnected) {
          note = document.createElement('p');
          container.append(note);
          notes.set(name, note);
        }
        if (note.textContent !== text) note.textContent = text;
        help.classList.add('igp-guidance-relocated');
      });
    };
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(relocateGuidance);
    });
    if (main) {
      observer.observe(main, {childList: true, subtree: true, characterData: true});
      relocateGuidance();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
